module.exports = __webpack_public_path__ + "img/planti.dc5eaaf6.svg";